export default async function (token) {
  return await fetch(`${process.env.VUE_APP_API_URL}/voter/profile`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
}
